import { Controller } from "@hotwired/stimulus";

// Profession Table from Old Dragon LB2
// Source: db/seeds/chapters/lb2/10-funil-com-ajudantes.md (Table A3.2)

export default class extends Controller {
	static targets = ["input", "tableBody"];
	static values = { choicePlaceholder: String };

	// Table A3.2: Profissões Anteriores (1d100)
	static PROFESSIONS = [
		{ range: [1, 10], name: "Vagabundo", description: "Vagabundo, Lunático ou Profeta do apocalipse" },
		{ range: [11, 30], name: "Camponês", description: "Camponês (fazendeiro, produtor de cereais, frutas, alimentos e animais de criação)" },
		{ range: [31, 45], name: "Trabalhador braçal", description: "Trabalhador braçal sem especialização" },
		{ range: [46, 48], name: "Armeiro", description: "Armeiro (fazer e reparar armas e armaduras de metal e couro)" },
		{ range: [49, 51], name: "Flecheiro", description: "Flecheiro (fazer e reparar arcos e flechas)" },
		{ range: [52, 54], name: "Pescador", description: "Pescador (uso de redes, navegação básica e natação)" },
		{ range: [55, 57], name: "Mateiro", description: "Mateiro (caça e coleta de animais ou plantas, uso de trilhas e armadilhas)" },
		{ range: [58, 60], name: "Jogador", description: "Jogador (jogos de azar, apostas e matemática)" },
		{ range: [61, 62], name: "Cavalariço", description: "Cavalariço (lidar com animais de montaria)" },
		{ range: [63, 64], name: "Joalheiro", description: "Joalheiro (avaliação, lapidação e comércio de joias, gemas, pedras preciosas e itens de valor)" },
		{ range: [65, 66], name: "Curtidor", description: "Curtidor (esfola, tratamento de couro e curtume em geral)" },
		{
			range: [67, 68],
			name: "Calígrafo",
			description: "Calígrafo e Desenhista (leitura e escrita, serviços administrativos e desenhos técnicos ou cartográficos)",
		},
		{ range: [69, 70], name: "Cinzelador", description: "Cinzelador (trabalho e corte de pedras brutas para construções)" },
		{ range: [71, 72], name: "Minerador", description: "Minerador (corte de rochas, escavamento de túneis e avaliação de rochas e metais brutos)" },
		{ range: [73, 74], name: "Marinheiro", description: "Marinheiro (navegação, condução de barcos, uso de cordas e natação)" },
		{ range: [75, 76], name: "Carpinteiro", description: "Carpinteiro (serviços básicos e estruturais em madeira)" },
		{ range: [77, 78], name: "Alfaiate", description: "Alfaiate/Tecelão (costura de roupas e fabricação de tecidos, linhas e cordames)" },
		{ range: [79, 80], name: "Cocheiro", description: "Cocheiro/Mecânico (condução, construção e conserto de carroças, carroções e carros)" },
		{ range: [81, 82], name: "Mercador", description: "Mercador (compra e venda de itens gerais)" },
		{ range: [83, 84], name: "Ferreiro", description: "Ferreiro (fabrica objetos de metal em geral)" },
		{ range: [85, 86], name: "Marceneiro", description: "Marceneiro (construção de móveis e entalhes em madeira)" },
		{ range: [87, 88], name: "Taverneiro", description: "Taverneiro (cozinha, cervejaria, fermentação e destilação)" },
		{ range: [89, 90], name: "Estudante", description: "Estudante (auxiliar e estudante de algum campo de conhecimento ou religioso)" },
		{ range: [91, 100], name: null, description: "A Escolha do Jogador" },
	];

	connect() {
		if (this.hasTableBodyTarget) {
			this.generateTable();
		}
	}

	generateTable() {
		const rows = this.constructor.PROFESSIONS.map((entry) => {
			const rangeText = this.formatRange(entry.range);
			return `<tr data-range="${entry.range[0]}-${entry.range[1]}">
				<td class="px-2 py-2">${rangeText}</td>
				<td class="px-2 py-2">${entry.description}</td>
			</tr>`;
		}).join("");

		this.tableBodyTarget.innerHTML = rows;
	}

	formatRange([start, end]) {
		const startStr = start.toString().padStart(2, "0");
		const endStr = end.toString().padStart(2, "0");
		return startStr === endStr ? startStr : `${startStr}-${endStr}`;
	}

	roll(event) {
		event.preventDefault();

		const roll = Math.floor(Math.random() * 100) + 1;
		const entry = this.findProfessionEntry(roll);

		this.clearHighlight();

		if (entry?.name) {
			this.inputTarget.value = entry.name;
		} else {
			// 91-100: Player's choice - clear the field to let them type
			this.inputTarget.value = "";
			this.inputTarget.focus();
			this.inputTarget.placeholder = this.choicePlaceholderValue;
		}

		this.highlightRow(entry);
	}

	findProfessionEntry(roll) {
		for (const entry of this.constructor.PROFESSIONS) {
			if (roll >= entry.range[0] && roll <= entry.range[1]) {
				return entry;
			}
		}
		return null;
	}

	clearHighlight() {
		if (this.hasTableBodyTarget) {
			this.tableBodyTarget.querySelectorAll("tr").forEach((row) => {
				row.classList.remove("odo-row-highlight");
			});
		}
	}

	highlightRow(entry) {
		if (this.hasTableBodyTarget && entry) {
			const selector = `tr[data-range="${entry.range[0]}-${entry.range[1]}"]`;
			const row = this.tableBodyTarget.querySelector(selector);
			if (row) {
				row.classList.add("odo-row-highlight");
				row.scrollIntoView({ behavior: "smooth", block: "nearest" });
			}
		}
	}
}
